import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export const FinancialLoader: React.FC = ({ ...props }) => {
  return (
    <>
      <Box {...props}>
        <Skeleton
          variant="text"
          component="div"
          width="40%"
          height={24}
          animation="wave"
        />
      </Box>
      <Box my={1}>
        <Skeleton
          variant="text"
          component="div"
          width="75%"
          height={20}
          animation="wave"
        />
      </Box>
    </>
  );
};
